export function secondsToTimestamp(seconds: number): string {
  const date = new Date(seconds * 1000).toISOString();
  return seconds > 36000 ? date.substr(11, 8) : date.substr(14, 5);
}
